import { ThemeProvider } from '@components/ThemeProvider/ThemeProvider';
import { ToastProvider } from '@components/Toast/ToastProvider';
import CustomQueryClientProvider from '@api/CustomQueryClientProvider';
import AppBootstrap from '@/core/AppBootstrap';

export function AppProviders(): React.ReactNode {
  return (
    <ThemeProvider>
      <ToastProvider>
        <CustomQueryClientProvider>
          <AppBootstrap />
        </CustomQueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
